import _isEmpty from 'lodash/isEmpty';

const fields = ['uri', 'title', 'options'];

export default class UrlModel {
	constructor(args = {}) {
		if (!_isEmpty(args)) {
			fields.forEach((field) => {
				this[field] = args[field];
			});
		}
	}
}
